/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_View_PacksInputs */

const en_btn_view_packs = /** @type {(inputs: Btn_View_PacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Packs`)
};

const ar_btn_view_packs = /** @type {(inputs: Btn_View_PacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض الحزم`)
};

const de_btn_view_packs = /** @type {(inputs: Btn_View_PacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakete ansehen`)
};

const es_btn_view_packs = /** @type {(inputs: Btn_View_PacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver packs`)
};

const fr_btn_view_packs = /** @type {(inputs: Btn_View_PacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir les packs`)
};

const it_btn_view_packs = /** @type {(inputs: Btn_View_PacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizza i pacchetti`)
};

const ja_btn_view_packs = /** @type {(inputs: Btn_View_PacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パックを見る`)
};

const ko_btn_view_packs = /** @type {(inputs: Btn_View_PacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팩 보기`)
};

const pt_br_btn_view_packs = /** @type {(inputs: Btn_View_PacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver pacotes`)
};

const ru_btn_view_packs = /** @type {(inputs: Btn_View_PacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смотреть пакеты`)
};

const th_btn_view_packs = /** @type {(inputs: Btn_View_PacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูแพ็คเกจ`)
};

const tr_btn_view_packs = /** @type {(inputs: Btn_View_PacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paketleri görüntüle`)
};

const zh_cn_btn_view_packs = /** @type {(inputs: Btn_View_PacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看加速包`)
};

const zh_tw_btn_view_packs = /** @type {(inputs: Btn_View_PacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看加速包`)
};

/**
* | output |
* | --- |
* | "View Packs" |
*
* @param {Btn_View_PacksInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_view_packs = /** @type {((inputs?: Btn_View_PacksInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_View_PacksInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_view_packs(inputs)
	if (locale === "ar") return ar_btn_view_packs(inputs)
	if (locale === "de") return de_btn_view_packs(inputs)
	if (locale === "es") return es_btn_view_packs(inputs)
	if (locale === "fr") return fr_btn_view_packs(inputs)
	if (locale === "it") return it_btn_view_packs(inputs)
	if (locale === "ja") return ja_btn_view_packs(inputs)
	if (locale === "ko") return ko_btn_view_packs(inputs)
	if (locale === "pt_br") return pt_br_btn_view_packs(inputs)
	if (locale === "ru") return ru_btn_view_packs(inputs)
	if (locale === "th") return th_btn_view_packs(inputs)
	if (locale === "tr") return tr_btn_view_packs(inputs)
	if (locale === "zh_cn") return zh_cn_btn_view_packs(inputs)
	return zh_tw_btn_view_packs(inputs)
});